import { render, staticRenderFns } from "./right_panel_year_arrivals.vue?vue&type=template&id=f08c51a4&scoped=true"
import script from "./right_panel_year_arrivals.vue?vue&type=script&lang=js"
export * from "./right_panel_year_arrivals.vue?vue&type=script&lang=js"
import style0 from "./right_panel_year_arrivals.vue?vue&type=style&index=0&id=f08c51a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08c51a4",
  null
  
)

export default component.exports